import Footer from '../../components/Footer/Footer';
import NavBar from '../../components/NavBar/NavBar';
import './Register.css';
import { Link, useHistory } from 'react-router-dom';
import { useState } from 'react';
import Swal from 'sweetalert2'

const Register = () => {
    const axios = require('axios');

    const [nameInput, setNameInput] = useState("");
    const [addressInput, setAddressInput] = useState("");
    const [emailInput, setEmailInput] = useState("");
    const [phoneNumberInput, setPhoneNumberInput] = useState("");
    const [passwordInput, setPasswordInput] = useState("");
    const history = useHistory();

    const handleNameChange = (e) => {
        setNameInput(e.target.value);

    }

    const handleAddressChange = (e) => {
        setAddressInput(e.target.value);
    }

    const handleEmailChange = (e) => {
        setEmailInput(e.target.value);
    }

    const handlePhoneNumberChange = (e) => {
        setPhoneNumberInput(e.target.value)
    }

    const handlePasswordChange = (e) => {
        setPasswordInput(e.target.value)
    }

    const handleConfirmPasswordChange = (e) => {
        if (e.target.value !== passwordInput)
            document.querySelector(".passwordnotmatchalert").style.display = "flex";
        else document.querySelector(".passwordnotmatchalert").style.display = "none";
    }

    const handleRegisterClick = (e) => {
        if (nameInput == "" || addressInput == "" ||
        emailInput == "" || phoneNumberInput == "" || passwordInput == "") {
            Swal.fire({
                text: "Mohon isi data dengan benar.",
                icon: "warning",
                showCancelButton: false,
                showConfirmButton: false,
                timer: 1000
            });
        } else {
            e.preventDefault();
            console.log(emailInput, nameInput, addressInput, passwordInput, phoneNumberInput)
            const data = JSON.stringify({
                email: emailInput,
                name: nameInput,
                address: addressInput,
                phoneNumber: phoneNumberInput,
                password: passwordInput
            })

            fetch("https://backend-markopedia.herokuapp.com/api/register", {
                method: "POST",
                body: data,
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                }
            })
                .then(res =>
                    res.json()
                ).then(res => {
                    if (res.status === "OK") {
                        console.log(res);
                        alert("Registration success.")
                        history.push("/login")
                    } else {
                        alert("Registration failed. Please try again.")
                    }

                }
                );
        }
    }

    return (
        <>
            <NavBar />
            <div className="register-wrapper">
                <h3>Silakan Daftarkan Akun Anda</h3>
                <div className="register-registerinput-wrapper">
                    <div className="firstandlastnamewrapper">
                        <input onChange={handleNameChange} required id="firstnameinput" placeholder="Nama" type="text"></input>
                        <div>

                        </div>
                        <input onChange={handleAddressChange} required id="lastnameinput" placeholder="Alamat" type="text"></input>
                    </div>
                    <div className="emailandmobilewrapper">
                        <input onChange={handleEmailChange} required id="emailinput" placeholder="Email" type="text"></input>
                        <div>

                        </div>
                        <input onChange={handlePhoneNumberChange} required id="mobilephoneinput" placeholder="Nomor Telepon" type="text"></input>
                    </div>
                    <input onChange={handlePasswordChange} required id="passwordinput" placeholder="Password" type="password"></input>
                    <input onChange={handleConfirmPasswordChange} required id="confirmpasswordinput" placeholder="Konfirmasi Password" type="password"></input>
                </div>
                <div className="passwordnotmatchalert">Password doesn't match!</div>
                <div onClick={handleRegisterClick} className="register-btn">
                    <a>Register</a>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default Register;
